module.exports = __webpack_public_path__ + "img/england.d39f7a13.svg";